<template>
  <v-form ref="form" v-model="valid">
    <v-container>
      <v-text-field v-model="q.title" :label="$t('question.form.title')" :tabIndex="1"></v-text-field>
      <v-textarea filled :label="$t('question.form.body')" v-model="q.body" :tabIndex="2"></v-textarea>
      <v-text-field v-model="q.author" :label="$t('question.form.author')" :tabIndex="3"></v-text-field>
      <v-btn color="primary" dark @click="saveQuestion()">{{ $t("common.form.save") }}</v-btn>
    </v-container>
  </v-form>
</template>

<script>
import axios from "axios";
import { formatMixin, listMixin, formMixin } from "@/helpers/mixins";

export default {
  name: "question",

  mixins: [formatMixin, listMixin, formMixin],

  data() {
    return {
      valid: true,
      q: {
        author: "",
        body: "",
        rating: 0,
      },
    };
  },

  props: ["customer", "type", "onSaved", "state"],

  methods: {
    init: function() {
      this.reset();
    },

    reset: function() {
      this.$refs.form.reset();
      this.$refs.form.resetValidation();
    },

    getData: function() {
      if (this.$refs.form.validate()) {
        return { ...this.q, customer: this.customer, type: this.type };
      } else {
        return null;
      }
    },

    saveQuestion: function() {
      if (!this.q.title || !this.q.body) {
        this.$store.dispatch("showSnackMessage", { message: this.$i18n.t("question.missingContent") });
        return
      }
      let q = { ...this.q, customer: this.customer, type: this.type, state: this.state };
      if (q) {
        axios
          .post(`/api/questions`, q)
          .then((q) => {
            this.onSaved(q.data);
          })
          .catch((e) => {
            console.log(e);
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
